module.exports = __webpack_public_path__ + "static/media/VGT_220.6257b8fc.png";